module.exports = __webpack_public_path__ + "img/hamberger-btn.2f859f10.svg";